import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {cookiesSetI18Lang, cookiesGetI18Lang} from './utils/auth'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./languages', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function loadLocaleDefault () {
  let langDefault = 'jp'
  if (cookiesGetI18Lang()) {
    langDefault = cookiesGetI18Lang()
  } else {
    cookiesSetI18Lang(langDefault)
  }

  return langDefault
}

const i18n = new VueI18n({
  locale: loadLocaleDefault(),
  fallbackLocale: 'jp',
  messages: loadLocaleMessages()
})

export default i18n
